export function initServiceCards() {
    const cards = document.querySelectorAll('[data-service-card]');
    if (!cards.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('service-card--visible');
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.2 });

    cards.forEach(card => {
        card.classList.add('service-card--ready');
        observer.observe(card);
    });
}
